<template>
  <div>
    <div v-if="!hideAddPayout" class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addPayout">
        <i class="fa fa-plus"></i> Add Payout
      </a>
    </div>
    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="''"
              id="payoutsTable" class="table-striped" 
              :data="data" :row-class-name="rowClasses">
      <!-- <el-table-column type="index">

      </el-table-column> -->
      
      
      <el-table-column width="120" label="Date">
        <template slot-scope="{row}">
          <template v-if="row">
            {{displayDate(row.dateCreated)}}
          </template>
        </template>
      </el-table-column>

      <el-table-column width="130" v-if="!forAffiliate && ($store.getters.companySelected == 0)" label="Company">
        <template slot-scope="{row}">
          <template v-if="row">
            {{ getCompanyName(row) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column width="25">
        <template slot-scope="{row}">
          <template v-if="!hasActiveCard(row)">
            <i v-tooltip.center-top="`No active card yet, can't submit payout`" class="fas fa-ban fa-sm"/>
          </template>
        </template>
      </el-table-column>

      <el-table-column v-if="!forAffiliate " label="Affiliate">
        <template slot-scope="{row}">
          <template v-if="row">
            {{ $store.getters.getAffiliateName(row.affiliateId) }}
          </template>
        </template>
      </el-table-column>
      
      <el-table-column width="85" label="Amount">
        <template slot-scope="{row}">
          <template v-if="row">
            <div :id="'amountDiv'+row.id" class="toShowWhenClosing">
              <span :id="'amountValue'+row.id">
                {{ $store.getters.currency + row.amount }}
              </span>
              <a v-if="!row.leadId && row.status == $store.getters.Payout._status.PENDING.value" class="btn-info text-primary btn-link d-none showOnHover mr-1" v-tooltip.top-center="'Change amount'"
                @click="editAmount(row.id)">
                <i class="fas fa-pencil-alt"></i>
              </a>
            </div>
            <div :id="'amountEditDiv'+row.id" class="d-none toHideWhenClosing"> 
              <input type="text" :id="'amountInput'+row.id" style="width: 40px"/>
              <a class="btn-info btn-link text-success" @click="saveEditAmount(row)" v-tooltip.top-center="'Save'"> <i class="ml-1 fas fa-check"/> </a>
              <a class="btn-info btn-link text-danger" @click="cancelEditAmount(row.id)" v-tooltip.top-center="'Cancel'"> <i class="ml-1 fas fa-times"/> </a>
            </div>
          </template>
        </template> 
      </el-table-column>
      
      <el-table-column width="85" label="Status">
        <template slot-scope="{row}">
          <template v-if="row">
            {{Object.values($store.getters.Payout._status).find(s => s.value == row.status)
              ? Object.values($store.getters.Payout._status).find(s => s.value == row.status).label
              : ''}}
          </template>
        </template>
      </el-table-column>
      
      <el-table-column width="120" label="Reason">
        <template slot-scope="{row}">
          <template v-if="row">
            {{Object.values($store.getters.Payout._type).find(t => t.value == row.type)
              ? Object.values($store.getters.Payout._type).find(t => t.value == row.type).label
              : ''}}
          </template>
        </template>
      </el-table-column>
      
      <el-table-column label="Details">
        <template slot-scope="{row}">
          <template v-if="row">
            <template v-if="row.leadId">
              {{$store.getters.leadsJson[row.leadId] ? $store.getters.leadsJson[row.leadId].name : '-'}}
            </template>
            <template v-else>
              <div :id="'noteDiv'+row.id" class="toShowWhenClosing">
                <span :id="'noteValue'+row.id">
                  {{row.note}}
                </span>
                <a v-if="row.status == $store.getters.Payout._status.PENDING.value" class="btn-info text-primary btn-link d-none showOnHover mr-1" v-tooltip.top-center="'Edit note'"
                  @click="editNote(row.id)">
                  <i class="fas fa-pencil-alt"></i>
                </a>
              </div>
              <div :id="'noteEditDiv'+row.id" class="d-none toHideWhenClosing">
                <input :id="'noteInput'+row.id" type="text"/>
                <a class="btn-info btn-link text-success" @click="saveEditNote(row)" v-tooltip.top-center="'Save'"> <i class="ml-1 fas fa-check"/> </a>
                <a class="btn-info btn-link text-danger" @click="cancelEditNote(row.id)" v-tooltip.top-center="'Cancel'"> <i class="ml-1 fas fa-times"/> </a>
              </div>
            </template>
          </template>
        </template>
      </el-table-column>


      <el-table-column v-if="selectObjects" width="30">
        <template slot-scope="{row}">
          <!-- <a class="btn-info btn-link"> <i class="far fa-square"/></a> -->
          <div>
            <l-checkbox v-show="rowSelectable(row)" :id="'selectpayout'+row.id" @change="selectRow(row)"/>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :payoutid="row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>  
</template>

<script>
import {Affiliate, AffiliateCompanyProxy, Payout, Lead} from 'src/classes/datamodel.js'
import utils from '../../utils'
export default {
    name: 'Payouts-Table',
    props: {
      //forCompany:     {type: Object, default: null},
      forAffiliate:   {type: Object, default: null},
      hideAddPayout:  {type: Boolean, default: false}
    },
    computed: {
      data () {
        //console.log('data(): ', this.$store.getters.affiliates)
        switch (true) {
         /*  case (this.forCompany && !!this.forCompany.id):
            return this.$store.getters.getPayoutsForCompany(this.forCompany.id).payouts
            break; */
          case (this.forAffiliate && !!this.forAffiliate.id):
            return this.$store.getters.getPayoutsForAffiliate(this.forAffiliate.id).payouts
          default:
            return this.$store.getters.payouts
        }
      },
      selectObjects () {
        // return false if a modal is currently open
        return !this.$store.getters.modal.current && this.$store.getters.selectedObjectsJson
      }
    }, 
    methods: {
      displayDate (date) {
        return utils.dateToString(date)
      },
      hasActiveCard (row) {
        const aff = this.$store.getters.affiliatesJson[row.affiliateAccountId]
        return !!aff && aff.paymentCardStatus == 'active'
      },
      getCompanyName (row) {
        if (row.affiliateId && this.$store.getters.affiliatesJson[row.affiliateAccountId]) {
          return this.$store.getters.getCompanyName(this.$store.getters.affiliatesJson[row.affiliateAccountId].affiliateCompanyId)
        }
        return '-'
      },
      addPayout () {
        var obj = this.forAffiliate && this.forAffiliate.id ? {affiliateId: this.forAffiliate.id} : {}
        obj.type = Payout._type.MANUAL.value
        this.$store.dispatch('openModal', {name: 'Payout', mode: 'Create', object: new Payout(obj)})
      },
      editAmount (rowId) {
        // we hide the text in the corresponding span and show an input field
        var value = $('#amountValue'+rowId).text().trim()
        console.log('value: ', value)
        $('#amountDiv'+rowId).addClass('d-none')
        $('#amountEditDiv'+rowId).removeClass('d-none')
        $('#amountInput'+rowId).val(value.split(this.$store.getters.currency)[1])
      },
      cancelEditAmount (rowId) {
        $('#amountEditDiv'+rowId).addClass('d-none')
        $('#amountDiv'+rowId).removeClass('d-none')
      },
      async saveEditAmount (row) {
        var payout = new Payout(row)
        var val = $('#amountInput'+row.id).val()
        payout.amount = val ? (Number(val) ? Number(val) : 0) : 0
        console.log('payout = ', payout)
        const res = await this.$store.dispatch('updateRestObject', payout)
        if (res.errors) {
          if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Saved!'})
          this.$store.commit('CLOSE_MODAL')
          this.cancelEditAmount(row.id)
        }
      },
      editNote (rowId) {
        // we hide the text in the corresponding span and show an input field
        var value = $('#noteValue'+rowId).text().trim()
        console.log('value: ', value)
        console.log('noteDiv: ', $('#noteDiv'+rowId).length)
        $('#noteDiv'+rowId).addClass('d-none')
        $('#noteDiv'+rowId).addClass('d-none')
        $('#noteEditDiv'+rowId).removeClass('d-none')
        $('#noteInput'+rowId).val(value)
      },
      cancelEditNote (rowId) {
        $('#noteEditDiv'+rowId).addClass('d-none')
        $('#noteDiv'+rowId).removeClass('d-none')
      },
      async saveEditNote (row) {
        var payout = new Payout(row)
        console.log('row = ', row)
        payout.note = $('#noteInput'+row.id).val()
        const res = await this.$store.dispatch('updateRestObject', payout)
        if (res.errors) {
          if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Saved!'})
          this.$store.commit('CLOSE_MODAL')
          this.cancelEditNote(row.id)
        }
      },
      rowClasses ({row, rowIndex}) {
        return row.archived ?'archivedTableRow' : ''
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#payoutsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#payoutsTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      // This method is called when clicking a checkbox to select a row
      // It's going to update the ObjectsWithId in the state (selectedObjects.objectsJson)
      selectRow (row) {
        this.$store.commit('SELECT_OBJECT', row)
      },
      rowSelectable (row) {
        if (this.$store.getters.selectedObjectsJson) { // if selection mode is active
          let filter = this.$store.getters.selectedObjectsFilter
          let filterKeys = filter ? Object.keys(filter) : []
          // we also check that the corresponding affiliate has an active card, and filter out otherwise
          let match = this.hasActiveCard(row)
          // we check the filter values
          filterKeys.forEach(key => {
            if (row[key] != filter[key]) {
              match = false
            }
          });
          return match
        }
        return false
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>